import script from "./DownArrowIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownArrowIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__